module.exports = __webpack_public_path__ + "img/ring_g_o_1_0@2x.78d4187b.png";